import * as React from 'react';

import { WHOLE_NUMBER_PATTERN } from 'common/utils/numberUtils';

export const useIsSearchingByGtin = (searchQuery: string) => {
  return React.useMemo(
    () => searchQuery.length >= 8 && WHOLE_NUMBER_PATTERN.test(searchQuery),
    [searchQuery],
  );
};
